import { NaverPayDeliveryType } from 'common/constants/naverPay'
import { SelectedDeliveryOption } from 'common/ducks/product/option'
import DeliveryFeePayMethodType from './deliveryFeePayMethodType'

export interface DeliveryMethodAttribute {
  code: number
  name: string
  description: string
  etc: string
  naverPayCode?: NaverPayDeliveryType
}

enum DeliveryMethodType {
  NONE = 'NONE',
  DELIVERY = 'DELIVERY',
  DIRECT = 'DIRECT',
  VISIT_RECEIPT = 'VISIT_RECEIPT',
  QUICK_SERVICE = 'QUICK_SERVICE',
}
/**
 없음 : 없음
 택배 : 착불, 주문시 결제
 퀵서 : 착불
 직접수령: 없음
 */
namespace DeliveryMethodType {
  type DeliveryTypes = { [key in DeliveryMethodType]: DeliveryMethodAttribute }

  const deliveryTypes: DeliveryTypes = {
    NONE: { code: 0, name: '배송없음', description: null, etc: null, naverPayCode: NaverPayDeliveryType.NOTHING },
    DELIVERY: { code: 1, name: '택배', description: '택배', etc: null, naverPayCode: NaverPayDeliveryType.DELIVERY },
    DIRECT: {
      code: 2,
      name: '직접전달',
      description: '직접배송',
      etc: null,
      naverPayCode: NaverPayDeliveryType.DIRECT_DELIVERY,
    },
    VISIT_RECEIPT: {
      code: 3,
      name: '방문수령',
      description: '방문수령',
      etc: '방문수령',
      naverPayCode: NaverPayDeliveryType.VISIT_RECEIPT,
    },
    QUICK_SERVICE: {
      code: 4,
      name: '퀵서비스',
      description: '퀵서비스(착불)',
      etc: '착불',
      naverPayCode: NaverPayDeliveryType.QUICK_SVC,
    },
  }

  export const getNames = (types: DeliveryMethodType[]): string[] => {
    return types.map(type => deliveryTypes[type].name)
  }

  export const isValid = (types: DeliveryMethodType[]): boolean => {
    return types[0] !== DeliveryMethodType.NONE
  }

  export const getAttribute = (type: DeliveryMethodType): DeliveryMethodAttribute => {
    return deliveryTypes[type]
  }

  export const getType = (attr: DeliveryMethodAttribute): DeliveryMethodType => {
    return DeliveryMethodType[Object.keys(deliveryTypes).filter(e => deliveryTypes[e].code === attr.code)[0]]
  }

  export const getTypes = (types: DeliveryMethodType[]): DeliveryMethodAttribute[] => {
    return types.map(type => deliveryTypes[type])
  }

  export const isGeneralDelivery = (type: DeliveryMethodAttribute): boolean => {
    return type.code === deliveryTypes.DELIVERY.code || type.code === deliveryTypes.DIRECT.code
  }

  export const isVisitDelivery = (type: DeliveryMethodAttribute): boolean => {
    return type.code === deliveryTypes.VISIT_RECEIPT.code
  }

  export const isQuickServiceDelivery = (type: DeliveryMethodAttribute): boolean => {
    return type.code === deliveryTypes.QUICK_SERVICE.code
  }

  export const getNaverPayDeliveryCode = (option: SelectedDeliveryOption): NaverPayDeliveryType => {
    return option && option.attribute ? option.attribute.naverPayCode : NaverPayDeliveryType.NOTHING
  }
}

export default DeliveryMethodType
